<template>
    <div class="w-full">
        <div
            class="w-full relative overflow-hidden group"
            v-if="state.isVideoAvailable !== false"
        >
            <video
                class="bg-white cursor-pointer w-full min-h-20"
                oncontextmenu="return false"
                controlsList="nodownload"
                ref="videoPlayer"
                @click="togglePlay"
                data-setup="{}"
                @canplay="(e) => (state.duration = e.target.duration)"
                @timeupdate="(e) => (state.currentTime = e.target.currentTime)"
                @ended="UPDATE_SLIDE_PROGRESS(true)"
            >
                <source :src="videoSrc" type="video/mp4" />
            </video>
            <video-controlls
                class="absolute -bottom-12 group-hover:bottom-0 transition-all"
                :watchTime="state.currentTime"
                :duration="state.duration"
                :volume="state.volume"
                @volume-change="changeVolume"
                :isPlaying="state.isPlaying"
                @toggle-play="togglePlay"
                @request-fullscreen="requestFullscreen"
                @toggle-mute="toggleMute"
                @change-time="(time) => ($refs.videoPlayer.currentTime = time)"
            />
        </div>
        <div
            class="flex flex-col justify-start items-center px-4 py-8 bg-white"
            v-if="state.isVideoAvailable !== false"
        >
            <notes
                :watchTime="state.currentTime"
                @change-time="(time) => ($refs.videoPlayer.currentTime = time)"
            />
        </div>
        <div v-else class="mb-20" style="padding: 0 5vw">
            <div
                class="w-full max-w-4xl flex flex-col items-start justify-start"
            >
                <div
                    class="text-black text-lg w-full whitespace-pre-wrap font-semibold mt-10"
                >
                    Fehler bei der Videowiedergabe
                </div>
                <p
                    class="text-base text-black max-w-4xl whitespace-pre-line mt-8"
                >
                    Bei der Wiedergabe des Videos ist ein Fehler aufgetreten.<br />Bitte
                    melden Sie sich bei dem WAY Team, damit Sie diesen Fehler
                    beheben können.<br /><br />Überspringen Sie vorläufig dieses
                    Video<br />
                    und schauen Sie es sich zu einem späteren Zeitpunkt an.
                </p>
                <custom-button
                    @click="UPDATE_SLIDE_PROGRESS(true)"
                    class="w-72 h-11 mt-10"
                    :text="'Video überspringen'"
                    :bgColor="'bg-primary'"
                    :textColor="'text-white'"
                    :id="'skip-video-button'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    reactive,
    ref,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import { SLIDE_TYPES, STORE_TYPES } from "../../../../store/types";
import VideoControlls from "./VideoControlls.vue";
import { cloneData, getData } from "../../../../common/dataHelper";
import Notes from "./Notes.vue";
import ApiService from "../../../../common/apiService";
import CustomButton from "../../../../components/input/CustomButton.vue";
import { SentryService } from "../../../../common/sentryService";
export default defineComponent({
    components: { VideoControlls, Notes, CustomButton },

    setup() {
        const store = useStore();
        const videoPlayer = ref();
        /**
         *  State
         */
        const state = reactive({
            slide: null,
            volume: 70,
            currentTime: 0,
            duration: 0,
            isPlaying: false,
            isVideoAvailable: null, //if null loading if false not available
        });
        /**
         *  Functions
         */
        function togglePlay() {
            if (state.isPlaying) {
                state.isPlaying = false;
                videoPlayer.value.pause();
            } else {
                state.isPlaying = true;
                videoPlayer.value.play();
            }
        }
        function requestFullscreen() {
            if (videoPlayer.value.requestFullscreen) {
                videoPlayer.value.requestFullscreen();
            } else if (videoPlayer.value.msRequestFullscreen) {
                videoPlayer.value.msRequestFullscreen();
            } else if (videoPlayer.value.webkitRequestFullscreen) {
                videoPlayer.value.webkitRequestFullscreen();
            }
        }
        function changeVolume(volume) {
            state.volume = volume;
            videoPlayer.value.volume = state.volume / 100;
        }
        function toggleMute() {
            if (state.volume == 0) {
                changeVolume(70);
            } else {
                changeVolume(0);
            }
        }
        function UPDATE_SLIDE_PROGRESS(isFinished = false) {
            store.dispatch(
                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.UPDATE_SLIDE_PROGRESS}`,
                {
                    watchTime: Math.floor(state.currentTime),
                    slide: state.slide,
                    isFinished,
                }
            );
        }
        async function checkVideoSrc() {
            const response = await ApiService.query(
                `academy/slides/${GET_SLIDE.value.id}/checkAccess`
            );
            if ([403, 404].includes(getData(response, "response.status"))) {
                state.isVideoAvailable = false;
                SentryService.sendError({
                    message: "Video ist für den Nutzer nicht verfügbar.",
                    jsonObject: response,
                });
            } else {
                state.isVideoAvailable = true;
            }
        }
        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );
        const videoSrc = computed(() => {
            return `${process.env.VUE_APP_API_URL}/academy/slides/${GET_SLIDE.value.id}`;
        });

        /**
         *  Created
         */
        onMounted(() => {
            checkVideoSrc();
            state.slide = cloneData(GET_SLIDE.value);
            if (
                GET_SLIDE.value.progress &&
                !GET_SLIDE.value.progress.is_finished
            ) {
                videoPlayer.value.currentTime =
                    GET_SLIDE.value.progress.watch_time;
            }
        }),
            onUnmounted(() => {
                UPDATE_SLIDE_PROGRESS();
            });
        return {
            state,
            videoPlayer,
            togglePlay,
            toggleMute,
            changeVolume,
            requestFullscreen,
            UPDATE_SLIDE_PROGRESS,
            GET_SLIDE,
            videoSrc,
        };
    },
});
</script>
